<template>
  <form-field
    :label="label"
    :description="description"
    :delimiter="options.breakAfter"
    :data-qa="options.name || id"
    :error-schema="errorSchema"
    :files="files"
    error-placement="top"
  >
    <template #default="{ id: computedId }">
      <div v-for="option in checkboxOptions" :key="option.value" data-qa="option">
        <base-checkbox
          v-model="computedModel"
          :value="option.value"
          :name="computedId"
          v-bind="fieldProps"
          :label="option.label"
        />
      </div>
    </template>
  </form-field>
</template>

<script>
import BaseCheckbox from '@/components/form-fields/checkbox/checkbox';
import FormField from './form-field';

export default {
  name: 'FormFieldCheckbox',
  components: { FormField, BaseCheckbox },
  inject: ['setFormDataByPointer'],
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String, Array],
      default: undefined
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    },
    schema: {
      type: Object,
      required: true
    },
    errorSchema: {
      type: Array,
      default: () => []
    },
    id: {
      type: [String, Number],
      required: true
    },
    pointer: {
      type: String,
      required: true
    }
  },
  computed: {
    files() {
      return this.schema.metadata?.files ?? [];
    },
    computedModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.setFormDataByPointer(this.pointer, value);
        // (для type: array событие "change" теряется в недрах vjsf либы)
        // TODO: везде перевести для единообразия на setFormDataByPointer
        // this.$emit('change', value);
      }
    },
    checkboxOptions() {
      const enumItems = this.schema.items?.enum || this.schema.enum || [];
      const options = enumItems.filter((value) => value || value === 0 || value === false);
      return options.map((value) => {
        const label = this.options.trl?.[value] ?? String(value);
        return { value, label };
      });
    },
    fieldProps() {
      return {
        ...this.options,
        ...this.$attrs
      };
    }
  }
};
</script>

<i18n lang="json" />
